export const activityStatusMap = {
    active: {
      label: '启用',
      color: '#87d068'
    },
    inactive: {
      label: '已下线',
      color: '#f50'
    },
}
